import { Lock } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useI18n } from "@/context/I18nContext";

export function PrivacyNote({ className = "", align = "start" }) {
  const { t } = useI18n();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="privacy-note"
          className={`inline-flex items-center gap-1.5 rounded-full text-xs text-muted-foreground transition-colors hover:text-foreground ${className}`}
        >
          <Lock className="h-3.5 w-3.5" strokeWidth={1.5} /> {t("privacy.badge")}
        </button>
      </PopoverTrigger>
      <PopoverContent align={align} className="w-80 rounded-2xl" data-testid="privacy-note-detail">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage">
            <Lock className="h-4 w-4" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-sm font-medium">{t("privacy.title")}</p>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{t("privacy.detail")}</p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
